export default {
  Base_Url: 'https://wellingwallet.icu/',
  Base_api: '/api',
  wsUrl: 'wss://wellingwallet.icu/io',
  title: 'Wellington',
  rateType: "USDT",
  moneyType: "$",
  lang: 'en',
  areaCode: '163'
}